module.exports = __webpack_public_path__ + "img/gold-medal.752d52b1.png";